import type { FC } from 'react'
import type { BakeStatus } from '@/types'

import { cn } from '@/lib/utils'

interface StatusTagProps {
    status: BakeStatus
    className?: string
}

const STATUS: Record<BakeStatus, { label: string, tone: string, dot: string }> = {
    'fresh': {
        label: 'تازه',
        tone: 'border-foreground/20 text-foreground',
        dot: 'bg-foreground'
    },
    'selling-fast': {
        label: 'رو به اتمام',
        tone: 'border-amber/45 text-amber',
        dot: 'bg-amber'
    },
    'sold-out': {
        label: 'تمام شد',
        tone: 'border-line text-crust-soft',
        dot: 'bg-line-strong'
    }
}

export const statusLabel = (status: BakeStatus): string => STATUS[status].label

export const StatusTag: FC<StatusTagProps> = ({ status, className }) => {
    const { label, tone, dot } = STATUS[status]

    return (
        <span className={cn('inline-flex h-6 items-center gap-1.5 rounded-sm border px-2 text-[0.6875rem] leading-none font-medium tracking-[0.16em] uppercase whitespace-nowrap', tone, className)}>
            <span className={cn('size-1.5 rounded-full', dot)} aria-hidden='true' />
            {label}
        </span>
    )
}
